@let entry = basketProductLine | async;
<div class="wrapper" [class.sticky-padding]="sticky" #composite>
  <app-center-section #productContent>
    @if (savings) {
      <app-savings [savings]="savings"></app-savings>
    }
    <app-image-carousel [product]="product"></app-image-carousel>
    <div class="product-details" #description>
      <section class="product-summary">
        @if (!product.forSale && product.notForSaleDescription) {
          <div [innerHTML]="product.notForSaleDescription | sanitizeHtml" class="rich-text"></div>
        }

        <h1 class="product-details-name">{{ product.productDisplayTitle || product.productDisplayName }}</h1>
        @if (summaryLabel) {
          <span class="product-details-summary">{{ summaryLabel }}</span>
        }
        @if (!product.altPriceText) {
          <app-price [value]="price" class="price-text" [forceSuperscript]="true"></app-price>
        }
        <div class="discount-levels">
          @for (discountLevel of product.discountLevels; track discountLevel.id) {
            <div>
              <span>{{ discountLevel.displayText }}</span>
              @if (!discountLevel.hidePercentPerQuantity) {
                <span> {{ discountLevel.discountPercent }}% for {{ discountLevel.minimumQuantity }} stk. </span>
              }
            </div>
          }
        </div>
        @if (product.altPriceText) {
          <span class="price-text">{{ product.altPriceText }}</span>
        }
        @if (product.infoText) {
          <span class="product-info-text">{{ product.infoText }}</span>
        }
        <div #mainModuleTarget class="target"></div>
        @if (mainOptions) {
          @for (module of product.productModules; track module.id) {
            @if (module.main) {
              <app-product-main-options
                [module]="module"
                [composition]="composition"
                [locked]="!!(basketProductLine | async)"
                [highlightRequired]="requiredModules[module.id]"
                (add)="add($event)"
                (remove)="remove($event)"
              ></app-product-main-options>
            }
          }
        }
        <div class="product-buttons">
          @if (!showTopAddToBasket || !mainOnlyOptions) {
            <app-text-button class="basket-button" (click)="validateRequiredAndScroll(mainModuleTarget, modulesTarget)">
              {{ product.productPageButtonText ? product.productPageButtonText : combineMenuButtonLabel }}
            </app-text-button>
          }
          @if (showTopAddToBasket && !product.isAdvertisement) {
            <app-text-button
              [disabled]="!product.forSale || !!entry"
              class="basket-button"
              (click)="validateAndAddToBasket(mainModuleTarget, modulesTarget)"
            >
              {{ product.forSale ? sharedContent.addToBasketLabel : sharedContent.productNotForSale }}
            </app-text-button>
          }
          @if (product.alcoholPercent) {
            <img
              src="assets/images/sundhedsstyrelsen.png"
              alt="Aldersgrænse for salg: 16 år for alkohol under 16,5% og 18 år for alkohol fra 16,5%"
              class="age-restricted"
            />
          }
        </div>
      </section>
      <section #productDescription class="product-descriptions">
        @if (!product.productDeliveryLimit?.hidden && product.productDeliveryLimit; as deliveryLimit) {
          <div class="delivery-limit">
            @if (product | limit; as interval) {
              <mat-icon svgIcon="info"></mat-icon>
              @if (interval.from === interval.to) {
                <span>Udleveres næste gang {{ interval.from | date: 'fullDate' }}</span>
              }
              @if (interval.from !== interval.to) {
                <span> Udleveres næste gang mellem {{ interval.from | date: 'fullDate' }} og {{ interval.to | date: 'fullDate' }} </span>
              }
            }
          </div>
        }
        @if (product.productDescription) {
          @if (product.productDisplayTitle) {
            <h2>{{ product.productDisplayName }}</h2>
          }
          <div [innerHTML]="product.productDescription | sanitizeHtml" class="rich-text"></div>
        }

        <div class="expanded-description">
          @for (descriptionExtension of product.descriptionExtensions; track descriptionExtension.index) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  @if (descriptionExtension.icon) {
                    <mat-icon>{{ descriptionExtension.icon }}</mat-icon>
                  }
                  <h2>{{ descriptionExtension.title }}</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div [innerHTML]="descriptionExtension.content | sanitizeHtml" class="rich-text"></div>
            </mat-expansion-panel>
          }

          @if (product.allergens?.length > 0) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h2>Allergener</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="allergener">
                <span><mat-icon svgIcon="warning"></mat-icon>{{ getAllergensString(product.allergens) }}</span>
              </div>
            </mat-expansion-panel>
          }

          @if (product.alcoholPercent) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h2>Alkoholprocent</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="alcohol">
                <span>{{ product.alcoholPercent }} %</span>
              </div>
            </mat-expansion-panel>
          }

          @if (product.ingredients) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h2>Ingredienser</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ingredients">
                <p>{{ product.ingredients }}</p>
              </div>
            </mat-expansion-panel>
          }

          @if (product.nutrients?.length) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h2>Næringsindhold</h2>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <app-nutritional-content [content]="product.nutrients"></app-nutritional-content>
            </mat-expansion-panel>
          }
        </div>

        @if (product.displayPdfUrls && product.pdfUrls?.length > 0) {
          <div class="pdfs">
            <h2>{{ preparationGuideLabel }}</h2>
            <div class="pdflinks-wrapper">
              @for (pdfurl of product.pdfUrls; track pdfurl) {
                @let label = pdfurl | pdfName;
                @if (!isKiosk) {
                  <app-text-button target="_blank" [href]="pdfurl">
                    {{ label }}
                  </app-text-button>
                } @else {
                  <app-text-button target="_blank" (click)="openLinkDialog(label, pdfurl)">
                    {{ label }}
                  </app-text-button>
                }
              }
            </div>
          </div>
        }
      </section>
      @if (isMeny) {
        @for (productAddition of product.productAdditions; track productAddition.id) {
          @if (productAddition?.display) {
            <section class="product-additions-links">
              <h2>{{ productAddition.name }}</h2>
              <div class="product-additions-link-wrapper">
                @for (prodAdd of productAddition.products; track prodAdd.id) {
                  @if (prodAdd.forSale) {
                    <button class="unstyled-button product-additions-link" (click)="scroll(productAdditionsTarget)">
                      {{ prodAdd.productDisplayTitle || prodAdd.productDisplayName }}
                    </button>
                  }
                }
              </div>
            </section>
          }
        }
      }
    </div>
  </app-center-section>
  <div #modulesTarget class="target"></div>
  @for (module of product.productModules; track module.id) {
    @if (!module.main) {
      <app-product-picker
        [module]="module"
        [composition]="composition"
        [locked]="!!(basketProductLine | async)"
        [highlightRequired]="requiredModules[module.id]"
        [pictureCards]="module.pictureCards"
        (add)="add($event)"
        (remove)="remove($event)"
      ></app-product-picker>
    }
  }

  @if (strips?.length) {
    <app-strip-container [strips]="strips"></app-strip-container>
  }

  <div #productAdditionsTarget class="target"></div>
  @for (productAddition of product.productAdditions; track productAddition.id) {
    @if (productAddition.display) {
      <app-product-additions [additions]="productAddition"></app-product-additions>
    }
  }
</div>

<div class="total" [class.sticky]="sticky" #stickyBottom>
  @if (!isDagrofa) {
    <div>
      @if (entry) {
        <div @slide class="buy-more">
          @if (isFandanko) {
            <app-text-button onClick="history.back()">Køb mere</app-text-button>
          }
          @if (!isFandanko) {
            <app-text-button (click)="buyMore()">Køb mere</app-text-button>
          }
          <app-text-button [routerLink]="basketOverviewUrl">Kurv</app-text-button>
        </div>
      }
      <div class="total-price">
        <span class="name">{{ product.productDisplayName }}</span>
        @if (showAltPrice && product.altPriceText) {
          <span>{{ product.altPriceText }}</span>
        }
        @if (!(showAltPrice && product.altPriceText) && !entry) {
          <span> {{ compositePrice * (1 - discountLevelPercent / 100) | number: '.2-2' : locale }} {{ currency | displayCurrency }} </span>
        }
        @if (!(showAltPrice && product.altPriceText) && entry) {
          <span>{{ entry | sum | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
        }
      </div>
      <div class="controls">
        @if (!entry && !product.isAdvertisement) {
          <app-text-button
            [disabled]="!product.forSale"
            class="basket-button"
            (click)="validateAndAddToBasket(mainModuleTarget, modulesTarget)"
          >
            {{ product.forSale ? sharedContent.addToBasketLabel : sharedContent.productNotForSale }}
          </app-text-button>
        }
        @if (entry && !product.isAdvertisement) {
          <app-counter
            [minCount]="product.minCount"
            [lockRemove]="entry.quantity === composition.minCount"
            [count]="entry.quantity"
            (add)="addToBasket($event.quantity)"
            (remove)="removeFromBasket(entry.quantity, $event.quantity)"
          ></app-counter>
        }
        @if (entry && !product.isAdvertisement) {
          <app-icon-button class="delete-line" [icon]="deleteIcon" (click)="deleteFromBasket()"></app-icon-button>
        }
        @if (entry && product.isAdvertisement) {
          <app-text-button [disabled]="!product.forSale" class="basket-button" [routerLink]="contactUsUrl">
            {{ sharedContent.contactUs }}
          </app-text-button>
        }
      </div>
    </div>
  }

  @if (isDagrofa) {
    <div>
      <div class="selected-labels">
        @for (module of product.productModules; track module.id) {
          @if (module.maxPickCount === 1 || module.singles) {
            @for (product of module.products; track product.id) {
              @if (composition && !!composition?.moduleChoices[module.id]?.products[product.id]?.quantity) {
                <button class="selected-product unstyled-button" (click)="!entry && remove([module, product, null, 1])">
                  {{ product.productDisplayName }} <mat-icon svgIcon="delete"></mat-icon>
                </button>
              }
            }
          }
        }
      </div>
      @if (!showCounter) {
        @let selectCount = getSelectCount();
        @if (selectCount.minPickCount > 0) {
          <div class="total-price">
            <span>{{ selectCount.pickedCount }} valgt</span>
            @if (!validated) {
              <span class="name">Minimum {{ selectCount.minPickCount }} stk.</span>
            }
            @if (validated) {
              <span class="name">Klar til bestilling!</span>
            }
          </div>
        }
      }
      @if (showCounter) {
        <app-counter
          [minCount]="product.minCount"
          [count]="quantityCounter"
          [lockRemove]="quantityCounter === product.minCount"
          (add)="addToQuantityCounter($event.quantity)"
          (remove)="removeFromQuantityCounter($event.quantity)"
        ></app-counter>
      }
      @if (!entry && product.forSale && !product.isAdvertisement) {
        <app-text-button [disabled]="!validated" class="basket-button" (click)="openBasket()">
          {{ sharedContent.addToBasketLabel }}:
          {{ compositePrice * (1 - discountLevelPercent / 100) * quantityCounter | number: '.2-2' : locale }}
          {{ ' ' + currency | displayCurrency }}
        </app-text-button>
      }
      @if (!entry && !product.forSale) {
        <app-text-button [disabled]="!product.forSale" class="basket-button">
          {{ sharedContent.productNotForSale }}
        </app-text-button>
      }
      @if (!entry && product.forSale && product.isAdvertisement) {
        <app-text-button [routerLink]="contactUsUrl">
          {{ sharedContent.contactUs }}
        </app-text-button>
      }
    </div>
  }
</div>

<app-icon-button
  class="mobile-scroll-down"
  [@openClose]="mobileScrollDownShow ? 'open' : 'closed'"
  [icon]="arrowIcon"
  [smallIcon]="true"
  (click)="scroll(description)"
></app-icon-button>
